import Vue from 'vue'
import OrderPopup from './popup'

let PopupTem = Vue.extend(OrderPopup)
let instance
let popup = options => {
  if (!instance) {
    instance = new PopupTem()
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }
  instance.type = options.type
  instance.reasonList = options.reasonList
  instance.orderNo = options.orderNo
  instance.orderType = options.orderType
  instance.selectedIndex = options.selectedIndex || options.selectedIndex == 0
    ? options.selectedIndex
    : -1
  instance.orderBase = options.orderBase || {}
  instance.showAddCartOption = options.showAddCartOption || false
  instance.orderCommodityUnits = options.orderCommodityUnits
  instance.fullPath = options.fullPath || ''
  instance.routerFun = options.routerFun
  instance.show = false
  instance.tempTerminal = options.tempTerminal
  instance.orderEv = options.orderEv
  instance.isWeChatApp = false
  instance.disabledModifyAdress = options.disabledModifyAdress || false
  instance.orderRenewVO = options.orderRenewVO

  if (options.isList) {
    instance.isList = options.isList
  }
  // 避免弹窗突然出现
  setTimeout(() => {
    instance.show = true
  }, 50)
}
popup.close = () => {
  instance && (instance.show = false)
}
export default popup
